import _ from "lodash";
import React from "react";
import {useTabsSharedDataContext} from "../components_v2/TabsSharedData/TabsSharedData";
import {getErrorMessage} from "../../../utils/utils";
import {parseResponse} from "../../../utils/api";
import {getHashValue} from "../utils";
import {isCancel, useCancelableRequest} from "../../../hooks/useCancelableRequest";

const generateQueryParamsHash = (customerId, portfolios, startDate, endDate, withHistoricalPortfolios) => {
  const portfoliosDepotNumbers = JSON.stringify(_.sortBy(
    portfolios.map((portfolio) => portfolio.depotNumber)));
  return getHashValue(customerId, portfoliosDepotNumbers, startDate, endDate, withHistoricalPortfolios)
};

export function useUnrealizedProfitAndLossData(customerId, portfolios, startDate, endDate, withHistoricalPortfolios, dataProvider) {
  const [data, setData] = React.useState({
    data: null,
    loading: true,
    errors: null,
    updatedAt: undefined,
  });
  const getCancelToken = useCancelableRequest();

  const sharedData = useTabsSharedDataContext();

  const syncFromShared = () => {
    const sharedPortfolioData = !!sharedData
        ? sharedData.getDataValue('unrealized-profit-and-loss', generateQueryParamsHash(customerId, portfolios, startDate, endDate, withHistoricalPortfolios))
        : undefined;

      if (!!sharedPortfolioData && !sharedPortfolioData.errors && sharedPortfolioData.updatedAt !== data.updatedAt) {
        // sync internal hook data with shared data.
        setData(sharedPortfolioData);

        return true
      } else {
        return false;
      }
  };

  React.useEffect(() => {syncFromShared()}, [_.get(sharedData, 'updatedAt')]);

  React.useEffect(() => {
    if (!!customerId && !_.isEmpty(portfolios)) {

      const synced = syncFromShared();

      if (!synced){
        fetch();
      }
    }
  }, [
    customerId, JSON.stringify(portfolios),
    startDate, endDate, withHistoricalPortfolios]);

  const fetch = async () => {
    const cancelToken = getCancelToken();
    const hashKey = generateQueryParamsHash(customerId, portfolios, startDate, endDate, withHistoricalPortfolios);

    const state = {
      data: null,
      loading: true,
      errors: null,
      updatedAt: +new Date()
    };
    setData(state);
    // It is not possible to sync data with shared data in
    // hook because hook is not executed if component destroyed
    sharedData.setDataValue('unrealized-profit-and-loss', hashKey, state);

    try {

      const depotNumbers = portfolios.map((portfolio) => portfolio.depotNumber).filter((value) => !!value);

      let response = await dataProvider.getTransactionsData(customerId, depotNumbers, startDate, endDate,
        withHistoricalPortfolios, undefined, cancelToken);

      parseResponse(response, 'transactions', (data) => {
        const state = {
          data: data,
          loading: false,
          errors: undefined,
          updatedAt: +new Date()
        };
        setData(state);
        sharedData.setDataValue('unrealized-profit-and-loss', hashKey, state);
      }, (errors) => {
        const state = {
          data: null,
          loading: false,
          errors: getErrorMessage(errors),
          updatedAt: +new Date()
        };
        setData(state);
        sharedData.setDataValue('unrealized-profit-and-loss', hashKey, state);
      });
    }
    catch(errors) {
      const state = {
        data: null,
        loading: false,
        errors: getErrorMessage(errors),
        updatedAt: +new Date()
      };
      if(!isCancel(errors)) setData(state);
      sharedData.setDataValue('unrealized-profit-and-loss', hashKey, state);
    }
  };

  return data
}